import { type DatabaseFieldType } from '@databases/types/database';
import { DatabaseFilterType } from '@databases/types/database/view';

import type { FieldType } from '../field-types';

import { parseTextBasedFromHtml, renderTextBasedExportView } from './textBasedFieldType';

export { parseTextBasedFromHtml };

const textFieldType: FieldType<DatabaseFieldType.TEXT> = {
  supportedFilterTypes: [
    DatabaseFilterType.EQUALS,
    DatabaseFilterType.CONTAINS,
    DatabaseFilterType.EMPTY
  ],

  isCsvImportSupported: true,

  renderExportView: ({ value }) => renderTextBasedExportView(value),

  parseFromHtml: parseTextBasedFromHtml,

  getInitialValue: () => ({ plain: '' }),

  isEmptyValue: ({ value }) => !value.plain,

  isEqualValue: ({ value: value1 }, { value: value2 }) => value1.plain === value2.plain,

  getStringRepresentation: ({ value }) => value.plain
};

export default textFieldType;
